import { withStyles } from "@material-ui/core";
import React from "react";
import styles from "./styles";
import { NavLink } from "react-router-dom";
import { NEWS_IMAGE_BASE_URL } from "../../constants/ui";

function NewsItem(props) {
  const { item, classes, newsPage, seoNews } = props;
  return (
    <div className={newsPage === 1 ? classes.boxPage : classes.box}>
      <div className={classes.boxImg}>
        <NavLink
          title={item.seo_title}
          to={{
            pathname: `/tin-tuc/chi-tiet/${item.alias}`,
            state: { item, seoNews }
          }}
        >
          <img src={`${NEWS_IMAGE_BASE_URL}/big/${item.picture}?time=` + Date.now()} alt={item.name} />
        </NavLink>
      </div>
      <div className={classes.boxDetail}>
        <h4>
          <NavLink
            title={item.seo_title}
            to={{
              pathname: `/tin-tuc/chi-tiet/${item.alias}`,
              state: { item, seoNews }
            }}
          >
            {item.name}
          </NavLink>
        </h4>
        <h5>{item.seo_description}</h5>
      </div>
    </div>
  );
}

export default withStyles(styles)(NewsItem);
